import { isPlainObject } from "is-plain-object";
import { nanoid } from "nanoid";
function uniqueId() {
  return nanoid();
}
const serializableTypes = /* @__PURE__ */ new Set(["string", "number", "boolean", "undefined"]);
function isSerializable(value) {
  if (serializableTypes.has(typeof value) || value === null)
    return true;
  if (Array.isArray(value))
    return value.every(isSerializable);
  if (isPlainObject(value))
    return Object.values(value).every(isSerializable);
  return false;
}
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.onabort = (error) => reject(error);
    }
  });
}
function getIncrementedName(name, others) {
  let result = name;
  const set = new Set(others);
  while (set.has(result)) {
    result = /^.*(\d+)$/.exec(result)?.[1] ? result.replace(/(\d+)(?=\D?)$/, (m) => {
      return (+m + 1).toString();
    }) : `${result} 1`;
  }
  return result;
}
const checkFlag = (flag) => typeof flag === "boolean" ? flag : flag?.();
function snapToGrid(n, gridSize) {
  return Math.round(n / gridSize) * gridSize;
}
const VALID_URL_REGEX = new RegExp(
  /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i
);
function isValidUrl(url) {
  return VALID_URL_REGEX.test(url);
}
export {
  checkFlag,
  fileToBase64,
  getIncrementedName,
  isSerializable,
  isValidUrl,
  snapToGrid,
  uniqueId
};
//# sourceMappingURL=data.mjs.map
